import axios from "axios"

export const requester = (baseurl) => (path) => (config) => {
  config.baseURL = baseurl
  config.url = path
  return axios(config);
}
export const defaultConfig = () => ({
  method:"GET",
  headers:{
    "Content-Type":"application/x-www-form-urlencoded"
  },
  body:""
})
